// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import $ from 'jquery/dist/jquery.min'
import utils from '@/lib/utils'
import Alert from '@/components/dialog/Alert'
import 'jquery-weui/dist/lib/weui.min.css'
import 'jquery-weui/dist/css/jquery-weui.min.css'
import 'jquery-weui/dist/demos/css/demos.css'
import 'jquery-weui/dist/js/jquery-weui.min'
// import server from './server.config'
// import Vuex from 'vux'
// Vue.use(Vuex)
Vue.component('Alert', Alert)
Vue.config.productionTip = false
// window.$ = window.jQuery = jquery
// Vue.prototype.$ = jquery
Vue.prototype.utils = utils
window.utils = utils
window.$homeScroll = 0

let storage = window.localStorage
let token = storage.getItem('token')
let t = utils.getUrlKey('t')
if (t) {
  token = utils.getUrlKey('t')
  storage.setItem('token', token)
}

// 路由跳转时动态设置标题
router.beforeEach((to, from, next) => {
  // 如果没有token, 则跳转到授权地址
  if (to.meta.auth && to.path !== '/Error' && !token) {
    let type = utils.getBrowserType()
    let callback = encodeURIComponent(window.location.href)
    if (type === 'wx') {
      let HostUrl = 'https://wgy-api.wgygroup.cn'
      window.location.href = HostUrl + '/wechat/auth?callback=' + callback
      // window.location.href = host + '/wechat/auth?callback=' + encodeURIComponent(window.location.origin + to.path)
    } else {
      let HostUrl = 'https://wgy-web.wgygroup.cn'
      window.location.href = HostUrl + '/auth/code?callback=' + callback
    }
  }
  document.title = to.meta.title || '万果园家园'
  setTimeout(() => {
    // document.title = to.meta.title || '万果园家园'
  }, 500)
  // if (to.path != '/login' && !store.state.userInfo) {
  //   store.dispatch('getUserInfo')
  // }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  utils,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js